import React from "react"

import { AppLegendChips } from "@components"
import { useReportBackendApiPath } from "Pages/ReportsAlerts/Reports/@hooks"
import { selectedReportTypeTab } from "Pages/ReportsAlerts/Reports/@signals"
import { REPORT_TYPE_TABS } from "Pages/ReportsAlerts/Reports/@constants"
import { dsColorNew } from "@palette"


export default function ReportIconsLegend({ sx = {}, variant }) {
	const { reportType } = useReportBackendApiPath()
	const isRating = selectedReportTypeTab.value === REPORT_TYPE_TABS.RATING
	const isOneWay = selectedReportTypeTab.value === REPORT_TYPE_TABS.ONE_WAYS

	const analyzers = [{
		icon: "arrow-right-arrow-left",
		short: "One Way",
		label: "One Way Analyzer",
		color: dsColorNew.successText,
		condition: isOneWay,
	}, {
		icon: "clock-rotate-left",
		short: "Historical",
		label: "View in real time historical",
		condition: isOneWay,
	}, {
		icon: "tally",
		short: "LOR",
		label: "LOR Analyzer",
		condition: !reportType && !isRating && !isOneWay,
	}, {
		icon: "calendar-days",
		short: "DOR",
		label: "DOR Analyzer",
		color: dsColorNew.appBlue,
		condition: !reportType && !isRating && !isOneWay,
	}, {
		icon: "handshake",
		short: "Brokers",
		label: "Brokers Analyzer",
		color: dsColorNew.noteAmber,
		condition: !reportType && !isRating && !isOneWay,
	}, {
		icon: "chart-line",
		label: "Direct Site",
		color: dsColorNew.successText,
		condition: !reportType && !isRating && !isOneWay,
	}, {
		icon: "ranking-star",
		short: "Position",
		label: "Rank Analyzer",
		color: dsColorNew.textDark,
		condition: !reportType && !isRating && !isOneWay,
	}, {
		icon: "star",
		short: "Rating",
		label: "Rating analyzer",
		color: dsColorNew.noteAmber,
		condition: (!reportType || isRating) && !isOneWay,
	}]

	const downloads = [{
		icon: "cloud-arrow-down",
		short: "Report",
		label: "Download Report",
		color: dsColorNew.successText,
		condition: !isRating,
	}, {
		icon: "file-arrow-down",
		short: "Export",
		label: "Download Export",
		color: dsColorNew.appBlue,
		condition: !isRating,
	}, {
		icon: "cloud-arrow-down",
		short: "Multi-report",
		label: "Download multi-report",
		color: "colors.pink",
		// one way reports generate their own workbook now, and the icon already renders
		// for them, so the legend has to explain it
		condition: true,
	}, {
		icon: "file-arrow-down",
		short: "Multi-export",
		label: "Download multi-export",
		color: "colors.deepPurple",
		condition: !isRating && !isOneWay,
	}]

	return <AppLegendChips
		data-tour-id="tour-icons-legend"
		aria-label="Icons in the Date column"
		groups={[analyzers.filter(item => item.condition), downloads.filter(item => item.condition)]}
		variant={variant}
		sx={sx}
	/>
}
